module.exports = __webpack_public_path__ + "static/google-0058d320d14d66e57be4c07b3d8b04c7.png";